// src/components/MainLayout.tsx

import { Outlet } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Sidebar } from '@/components/Sidebar';
import { ContentBottomAd } from '@/components/AdBanner';

export const MainLayout = () => {
  return (
    <div className="relative min-h-screen md:flex">
      <Sidebar />
      
      <div className="md:ml-20 flex-1 flex flex-col transition-all duration-300 ease-in-out">
        <Header />
        
        <main className="p-6 md:p-8 flex-1 overflow-y-auto">
          <Outlet />
          
          {/* コンテンツ下部に広告を配置（Freeプランのみ表示） */}
          <ContentBottomAd />
        </main>
      </div>
    </div>
  );
};
